import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput, ColorInput } from '../../../Form';

@inject('ticketReasonStore')
@observer
class ReasonEdit extends Component {
  // static propTypes = {
    // route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
      // id: PropTypes.string.isRequired,
    // }).isRequired,
    // unitStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/reason';
  title = 'Edit Ticket Reason';

  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  constructor(props) {
    super(props);

    const { params: { id }, ticketReasonStore } = props;

    ticketReasonStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, ticketReasonStore } = this.props;
    const foundReason = ticketReasonStore.findById(id);
    if (foundReason) {
      this.item = foundReason.asJson;
    }
  }

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { ticketReasonStore } = this.props;
    ticketReasonStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const { ticketReasonStore, params: { id } } = this.props;

    if (ticketReasonStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={ticketReasonStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default ReasonEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Reason/ReasonEdit.js